import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        viewBox="0 0 886.926 886.926"
        style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "auto",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }}
        {...props}
    >
        {/* <path
            fill="#fefefe"
            d="M-.5-.5h800v372c-6.793-42.294-29.46-72.794-68-91.5a121.764 121.764 0 0 0-39-8.5 7747.008 7747.008 0 0 0-176-1c.332-45.17-.001-90.17-1-135 .103-30.952-8.73-58.952-26.5-84-19.855-23.01-45.022-35.51-75.5-37.5-20.408-1.949-40.408.051-60 6-5.833 2.5-10 6.667-12.5 12.5l-1 155c-3.521 37.211-19.355 68.044-47.5 92.5-26.399 21.872-56.066 38.038-89 48.5-7.145-10.748-17.145-17.248-30-19.5a5038.73 5038.73 0 0 0-142 0c-17.398 4.895-28.065 16.062-32 33.5V-.5Z"
            style={{
                opacity: 1
            }}
        /> */}
        <path
            fill="#521616"
            d="M515.5 135.5v136h177a121.764 121.764 0 0 1 39 8.5c38.54 18.706 61.207 49.206 68 91.5v25a33132.947 33132.947 0 0 0-47.5 291c-10.079 50.079-39.912 81.245-89.5 93.5a263.23 263.23 0 0 1-26 4c-123.333.667-246.667.667-370 0-26.237-4.117-48.571-15.617-67-34.5-7.13 7.399-15.796 11.899-26 13.5a5038.73 5038.73 0 0 1-142 0c-18.314-5.138-28.98-16.971-32-35.5v-386c3.935-17.438 14.602-28.605 32-33.5a5038.73 5038.73 0 0 1 142 0c12.855 2.252 22.855 8.752 30 19.5 32.934-10.462 62.601-26.628 89-48.5 28.145-24.456 43.979-55.289 47.5-92.5l1-155c2.5-5.833 6.667-10 12.5-12.5 19.592-5.949 39.592-7.949 60-6 30.478 1.99 55.645 14.49 75.5 37.5 17.77 25.048 26.603 53.048 26.5 84Z"
            style={{
                opacity: 1
            }}
        />
        <path
            fill="#FFC2C2" // Interior del pulgar
            d="M388.5 52.5c53.479-4.018 82.645 20.649 87.5 74l1 168c2.5 7.833 7.667 13 15.5 15.5l206 1c26.119 4.786 44.619 19.286 55.5 43.5 5.693 13.875 7.359 28.208 5 43a86847.36 86847.36 0 0 1-47 290c-8.046 30.046-27.212 48.546-57.5 55.5a118.037 118.037 0 0 1-19 3c-121.333.667-242.667.667-364 0-34.833-6.833-55.667-27.667-62.5-62.5a24951.774 24951.774 0 0 1 0-316c55.787-14.87 101.787-44.536 138-89 16.674-23.028 27.007-48.695 31-77 1.3-48.972 1.967-97.972 2-147a205.976 205.976 0 0 0 8.5-2Z"
            style={{
                opacity: 1
            }}
        />
        <path
            fill="#999"
            d="M515.5 135.5c.999 44.83 1.332 89.83 1 135 58.836-.332 117.502.001 176 1h-177v-136Z"
            style={{
                opacity: 1
            }}
        />
        <path
            fill="#FFC2C2" // Color interior Manga
            d="M39.5 347.5c43.239-.33 86.406.003 129.5 1 .832 125.57.666 251.07-.5 376.5-43.238.83-86.404.663-129.5-.5a23735.07 23735.07 0 0 1 .5-377Z"
            style={{
                opacity: 1
            }}
        />
        <path
            fill="#fdfdfd"
            d="M799.5 396.5v403H-.5v-71c3.02 18.529 13.686 30.362 32 35.5 47.333.667 94.667.667 142 0 10.204-1.601 18.87-6.101 26-13.5 18.429 18.883 40.763 30.383 67 34.5 123.333.667 246.667.667 370 0a263.23 263.23 0 0 0 26-4c49.588-12.255 79.421-43.421 89.5-93.5a33132.947 33132.947 0 0 1 47.5-291Z"
            style={{
                opacity: 1
            }}
        />
    </svg>
);
export default SvgComponent;